import { render, staticRenderFns } from "./BuyingListDetail.vue?vue&type=template&id=a0b51c3c&scoped=true"
import script from "./BuyingListDetail.vue?vue&type=script&lang=ts"
export * from "./BuyingListDetail.vue?vue&type=script&lang=ts"
import style0 from "./BuyingListDetail.vue?vue&type=style&index=0&id=a0b51c3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b51c3c",
  null
  
)

export default component.exports